import React from 'react';
import * as styles from './Divider.module.css';

export interface DividerProps {
  margin?: string;
  borderColor?: string;
  className?: string;
  orientation?: 'horizontal' | 'vertical';
  height?: string;
  'aria-hidden'?: boolean;
}

/**
 * セクション間の区切りに使用
 * デフォルトではmarginを16px 0に設定している
 */
const Divider: React.FC<DividerProps> = ({
  margin,
  borderColor = '#D9D9D9',
  className,
  orientation = 'horizontal',
  height,
  'aria-hidden': ariaHidden = true,
}) => {
  const isVertical = orientation === 'vertical';
  const defaultMargin = isVertical ? '0 16px' : '16px 0';

  const inlineStyle = {
    margin: margin !== undefined ? margin : defaultMargin,
    borderColor: borderColor || '#D9D9D9',
    ...(isVertical && height ? { height } : {}),
  };

  return (
    <hr
      className={`${styles.divider} ${isVertical ? styles.vertical : ''} ${className || ''}`}
      style={inlineStyle}
      aria-hidden={ariaHidden}
    />
  );
};

export default Divider;
